import { ProposalSource } from "generated/graphql";
import { z } from "zod";

export const CLOSE_CONFIDENCE_OPTIONS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100] as const;

export const updateProposalSchema = z.object({
  id: z.string().min(1, "Please provide the proposal id"),
  companyId: z.string().min(1, "Please select a company"),
  contactId: z.string().min(1, "Please select a contact"),
  source: z.nativeEnum(ProposalSource).optional(),
  projectedCloseDate: z.string().optional().nullable(),
  closeConfidence: z.coerce.number().int().min(0).max(100).optional().nullable(),
});

export type UpdateProposalFormValues = z.infer<typeof updateProposalSchema>;

export const getDefaultValues = (
  initialValues: Partial<UpdateProposalFormValues>
): UpdateProposalFormValues => ({
  companyId: "",
  contactId: "",
  id: "",
  source: undefined,
  projectedCloseDate: "",
  closeConfidence: null,
  ...initialValues,
});
